import { ActionTypes } from "../constants/action-types";

/*
Reducers for cart
*/
let cause_list;
let default_cause;
let user_cause;
let show_charity_active_message;
if (typeof window !== "undefined") {
  // Perform localStorage action
  cause_list = localStorage.getItem("cause_list");
  default_cause = localStorage.getItem("default_cause");
  user_cause = localStorage.getItem("user_cause");
  // try catch not required but just in case JSON.parse fails, catch error and set to null for safety
  try {
    cause_list = JSON.parse(cause_list);
  }
  catch(error) {
    cause_list = null;
  }
}

const initialState = {
  cause_list: cause_list,
  default_cause: default_cause,
  user_cause: user_cause,
  sidebar_cause: false,
  charitychange_popup_open: false,
  menu_data: false,
  global_active_tab: false,
  plp_wishlist_clicked:false,
  show_charity_active_message:false
};



export const generalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.INITIALIZE_CAUSE_DATA:
      return {
        ...state,
        cause_list: payload,
      };
    case ActionTypes.DEFAULT_CAUSE:
        return {
            ...state,
            default_cause: payload,
        };
    case ActionTypes.USER_CAUSE:
        return {
            ...state,
            user_cause: payload,
        };
    case ActionTypes.SIDEBAR_CAUSE:
          return {
            ...state,
            sidebar_cause: payload,
          };
    case ActionTypes.MENU_DATA:
      return {
        ...state,
        menu_data: payload,
      };
    case ActionTypes.GLOBAL_ACTIVE_TAB:
      return {
        ...state,
        global_active_tab: payload,
      };
    case ActionTypes.PLP_WISHLIST_CLICKED:
      return {
        ...state,
        plp_wishlist_clicked: payload,
      };
    case ActionTypes.SHOW_CHARITY_ACTIVE_MESSAGE:
      return {
        ...state,
        show_charity_active_message : payload
      }
    default:
      return state;
  }
};
